import { cn } from '@/lib/utils'

/** Mobile: horizontal scroll (first card ~94% width), left-aligned with section title. sm+: grid. */
export const productListLayoutClass = cn(
  'flex gap-4 overflow-x-auto pb-1 snap-x snap-mandatory scroll-smooth',
  'max-sm:-mr-4 max-sm:pr-4',
  '[scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden',
  'sm:mr-0 sm:grid sm:grid-cols-1 sm:overflow-visible sm:snap-none sm:pb-0 sm:pr-0',
  'md:grid-cols-2 lg:grid-cols-3 md:gap-4 lg:gap-5'
)

/** Mobile carousel item — same width as the lead card in every section. */
export const productListItemClass = cn(
  'shrink-0 snap-start max-sm:w-[94%] sm:w-auto sm:shrink'
)

/** Shop page: vertical grid at all breakpoints (page scrolls top to bottom). */
export const shopProductListLayoutClass = cn(
  'grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-4 lg:grid-cols-3 lg:gap-5'
)

export const shopProductListItemClass = 'min-w-0'
